import { BaseFacade } from '@colescba/services'
import { ReferenceDataService } from './reference-data.service'
import { SolicitudesService } from './solicitudes.service'
import { AutorizacionesService } from './autorizaciones.service'
import { ArchivoService } from './archivo.service'

export class Facade extends BaseFacade {
  createServices() {
    this.referenceData = new ReferenceDataService(this.config)
    this.solicitudes = new SolicitudesService(this.config)
    this.autorizaciones = new AutorizacionesService(this.config)
    this.archivo = new ArchivoService(this.config)

    return [this.referenceData, this.solicitudes, this.autorizaciones, this.archivo]
  }
}
